import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IMarkAllNotificationsAsReadResponse {
  updated: number;
}

export const markAllNotificationsAsRead =
  async (): Promise<IMarkAllNotificationsAsReadResponse> => {
    const { data } =
      await jhsfBookingsApi.patch<IMarkAllNotificationsAsReadResponse>(
        '/notifications/read-all',
      );

    return data;
  };
